import { Injectable } from '@angular/core';
import { Compagnie } from '../domaine/compagnie';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompagnieService {

  constructor(private http: HttpClient) { }

  all(): Observable<Compagnie[]>{
    return this.http.get<Compagnie[]>(`${ environment.apiUrl }/compagnie/`).pipe(
      catchError(
        err => {
           return this.handleError(err);
        }
      )
    );
  }


  add(criticite: Compagnie): Observable<Compagnie>{
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<Compagnie>(`${ environment.apiUrl }/compagnie/`, criticite, options).pipe(
      catchError(
        err => {
           return this.handleError(err);
        }
      )
    );
  }

  update(criticite: Compagnie): Observable<Compagnie>{
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.put<Compagnie>(`${ environment.apiUrl }/compagnie/` + criticite.id, criticite, options).pipe(
      catchError(
        err => {
           return this.handleError(err);
        }
      )
    );
  }

  delete(id: number): Observable<Compagnie>{
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.delete<Compagnie>(`${ environment.apiUrl }/compagnie/` + id).pipe(
      catchError(
        err => {
           return this.handleError(err);
        }
      )
    );
  }
  handleError(err: any){
    return throwError(err);
  }
}



